export const LOGIN = "LOGIN";

export const LOGOUT = "LOGOUT";

export const RESETSELFPASSWORD = "RESETSELFPASSWORD";

export const RESETUSERPASSWORD = "RESETUSERPASSWORD";

export const DELETEMANAGERUSER  = "DELETEMANAGERUSER";
export const DELETEOPERATORUSER = "DELETEOPERATORUSER";


export const login = user => {

  return {

    type: LOGIN,

    payload: user

  };

};


export const logout = userid => {

  return {

    type: LOGOUT,
    
    payload: userid

  };

};

export const resetSelfPassword = passwords => {

  return {

    type: RESETSELFPASSWORD,

    payload: passwords

  };

};

export const resetUserPassword = passwords => {

  return {

    type: RESETUSERPASSWORD,

    payload: passwords

  };

};

export const deleteManagerAccount = userid => {

  return {

    type: DELETEMANAGERUSER,

    payload: userid

  };

};

export const deleteOperatorAccount = userid => {

  return {

    type: DELETEOPERATORUSER,

    payload: userid

  };

};


